import { isHandled } from './handled_rejection'
import * as Sentry from 'shared/sentry'

/**
 * Do not generate errors for rejected promises marked as handled
 */
window.addEventListener('unhandledrejection', (event) => {
  // Prevent error output when already handled
  Sentry.captureMessage(
    'Unhandled promise rejection',
    {
      ...event,
    },
  )
  if (isHandled(event.reason)) event.preventDefault()
})
